import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueLazyLoad from "vue-lazyload";
import axios from "axios";

// import BaiduMap from 'vue-baidu-map'
// import { Toast } from 'vant'

// if (!isIOS()) {
//   window.clearAllWebviewCache();
// }

import Popover from "vue-js-popover";
Vue.use(Popover);

import waterfall from "vue-waterfall2";
Vue.use(waterfall);

var userAgent = window.navigator.userAgent;
if (userAgent.indexOf("Android") > -1) {
  require("./jsbridge.js"); // 兼容vivo低端机型
}

// Vue.use(BaiduMap, {
//   /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
//   ak: 'HXsEPSnocc9kxfbpVFEY49qdCwNfSwyd'
// })
// import echarts from 'echarts'
// 引入echarts
// import Vue from 'vue'

// let echarts = require('echarts/lib/echarts')
// require("echarts/lib/chart/gauge");
// Vue.prototype.$echarts = echarts

// console.log(process.env);
import VConsole from "vconsole";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (process.env.NODE_ENV == "production") {
  // const vConsole = new VConsole();
} else {
  // const script = document.createElement('script')
  // script.src = 'https://cdn.bootcss.com/vConsole/3.3.4/vconsole.min.js'
  // script.async = true
  // document.getElementsByTagName('head')[0].appendChild(script)
  // script.onload = function () {
  //   var vConsole = new VConsole() // 开启
  // }
  // const vConsole = new VConsole();
}

import { nanoid } from "nanoid";
if (!localStorage.getItem("bury_deviceid")) {
  localStorage.setItem("bury_deviceid", nanoid(32));
}
if (!sessionStorage.getItem("bury_startup_id")) {
  sessionStorage.setItem("bury_startup_id", nanoid(32));
}
// if(!localStorage.getItem("bury_visit_id")){
sessionStorage.setItem("bury_visit_id", nanoid(32)); //  visit_id每次刷新
// }

Vue.use(VueLazyLoad, {
  attempt: 2,
  filter: {
    optimizeImg(listener) {
      listener.src =
        listener.src && listener.src.replace("http://", "https://");
    },
  },
});
// store.dispatch('initialUserInfo')
// store.dispatch('lngLat/initialPosition')
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
var ua = navigator.userAgent; //获取浏览器UA
if (ua.indexOf("szd_SZGov") != -1) {
  setTimeout(() => {
    window.getNativeInfo((res) => {
      console.log("nativeinfo2", res);
      if (JSON.parse(res)) {
        store.commit("setnativeInfo", JSON.parse(res));
        let appversion = JSON.parse(res).appVersion || "0";
        let v = appversion.replace(/[.]/g, "").padEnd(4, "0");
        store.commit("setAppversion", v);
        store.commit("setAppversionString", appversion);
      }

      new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount("#app");
    });

    const token = store.getters.getToken;
    if (!token) {
      // 兼容ios
      window.getUserInfo((res) => {
        console.log("getUserInfo", res);
        sessionStorage.setItem("userInfo", res);
        // let id = JSON.parse(res).id || "";
        let idCard = JSON.parse(res).idCard || "";
        if (idCard) {
          window.getToken("getTokenSuccess");
          window.getTokenSuccess = (res2) => {
            console.log("getTokenSuccess", res2);
            localStorage.setItem('userToken', res2)
            store.commit("setToken", res2);
          };
        }
      });
    }

    window.getNativeStaticsPageInfo((res) => {
      // console.log('987', res);
      if (JSON.parse(res)) {
        store.commit("setpageInfo", JSON.parse(res));
      }
    });
  }, 100);
} else {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
